export default __webpack_public_path__ + "static/wag_dog_ie-fe3604f0657e85ca0ed3a75f94cfba44.png";